import type { LookupItem } from '../../../mocks/criminalMasterData';
import { todayIsoDateLocal } from '../../../utils/caseFieldValidation';

export function isHighUrgencyLevel(name: string): boolean {
  return name.trim().toLowerCase().startsWith('high');
}

export function minDeadlineDateForCivilAppellate(): string {
  return todayIsoDateLocal();
}

export function isOtherCorporateInstitute(id: string, name?: string, code?: string): boolean {
  if (code?.trim().toUpperCase() === 'OTHER') return true;
  if (id.trim().toLowerCase() === 'other') return true;
  return (name ?? '').trim().toLowerCase() === 'other';
}

export function selectedCorporateInstitute(
  corporateInstituteId: string,
  corporateInstitutes: LookupItem[],
): LookupItem | undefined {
  const id = corporateInstituteId.trim();
  if (!id) return undefined;
  return corporateInstitutes.find((c) => c.id === id);
}

export function isOtherCorporateInstituteSelected(
  corporateInstituteId: string,
  corporateInstitutes: LookupItem[],
  corporateInstituteName?: string,
): boolean {
  const item = selectedCorporateInstitute(corporateInstituteId, corporateInstitutes);
  return isOtherCorporateInstitute(
    corporateInstituteId,
    item?.name ?? corporateInstituteName,
    item?.code,
  );
}
